// extracted by mini-css-extract-plugin
module.exports = {"blogPosts":"index-module--blogPosts--2xjAJ","blogPostPreview":"index-module--blogPostPreview--SxsD_"};